import { ChatType } from '../../growegy-ai/dto';
import { useChatContext } from '../../growegy-ai/chat/chatContext';
import React, {
  ForwardedRef,
  forwardRef,
  ReactElement,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useForceRerender } from '../hooks/useForceRerender';
import { ChatListAndMessenger } from '../../growegy-ai/chat/components/ChatListAndMessenger';
import { IconWithGradientBackground } from './IconWithGradientBackground';
import { ArrowDown } from '../../assets/icons';
import { Chat } from '../../growegy-ai/types';

export type PopupChatFunctions = {
  expand: () => void;
  collapse: () => void;
};

export const PopupChat = forwardRef(
  (
    props: {
      systemMessage: string | (() => string) | null;
      chatType: ChatType;
      dataTestPrefix: string;
      right: number;
      bottom: number;
      top?: number;
      left?: number;
      width?: string;
      maxWidth?: number;
      icon: () => ReactElement;
      selectedChat?: Chat | null;
      onToolCallProceed?: () => void;
    },
    ref?: ForwardedRef<PopupChatFunctions>
  ) => {
    const {
      systemMessage,
      chatType,
      dataTestPrefix,
      right,
      bottom,
      top,
      left,
      width,
      maxWidth,
      icon: Icon,
      selectedChat,
      onToolCallProceed,
    } = props;
    const { getCurrentChat, setCurrentChat } = useChatContext();
    const [chat, setChat] = useState(getCurrentChat());
    const [expanded, setExpanded] = useState(false);
    const forceRerender = useForceRerender();
    useEffect(forceRerender, [forceRerender, expanded]);

    useEffect(() => {
      if (selectedChat) {
        setCurrentChat(selectedChat);
        setChat(selectedChat);
      }
    }, [selectedChat, setCurrentChat]);

    useImperativeHandle(
      ref,
      () => ({
        expand: () => setExpanded(true),
        collapse: () => setExpanded(false),
      }),
      []
    );

    return (
      <>
        {expanded && (
          <div
            className="messenger__popup"
            style={{ top, right, bottom: bottom + 56, left, width: width, maxWidth }}
          >
            <div className="messenger__popup-container">
              <ChatListAndMessenger
                layout="slim"
                chatType={chatType}
                selectedChat={chat}
                systemMessage={systemMessage}
                onChatSelected={(chat) => {
                  setCurrentChat(chat);
                  setChat(chat);
                }}
                onOpenLibraryClick={() => {}}
                onPromptClick={() => {}}
                onToolCallProceed={onToolCallProceed}
              />
            </div>
          </div>
        )}
        <div className="messenger__popup-toggle" style={{ right, bottom }}>
          <IconWithGradientBackground
            icon={expanded ? <ArrowDown className="growegy-ai__floating-button-icon" /> : <Icon />}
            isButton={true}
            onClick={() => setExpanded(!expanded)}
            dataTest={`${dataTestPrefix}__ai-toggle`}
          />
        </div>
      </>
    );
  }
);
